import React, { useCallback, useMemo } from 'react';
import { listToMap, _cs } from '@togglecorp/fujs';
import ListView from '../ListView/index.js';
import InputLabel from '../InputLabel/index.js';
import InputError from '../InputError/index.js';
import InputHint from '../InputHint/index.js';
import Button from '../Button/index.js';
import styles from './styles.css.js';

function MultiBadgeInput(props) {
  const {
    name,
    onChange,
    options,
    disabled,
    labelSelector,
    keySelector,
    titleSelector,
    iconSelector,
    value,
    listClassName,
    containerClassName,
    labelContainerClassName,
    errorContainerClassName,
    hintContainerClassName,
    buttonClassName,
    buttonVariant = 'tertiary',
    selectedButtonVariant = 'primary',
    label,
    error,
    hint,
    selectedValueHidden,
    smallButtons
  } = props;
  const handleOptionClick = useCallback(key => {
    if (!onChange) {
      return;
    }

    if (!value) {
      onChange([key], name);
      return;
    }

    if ((value === null || value === void 0 ? void 0 : value.findIndex(val => val === key)) === -1) {
      onChange([...value, key], name);
    } else {
      const newVal = value === null || value === void 0 ? void 0 : value.filter(val => val !== key);
      onChange((newVal === null || newVal === void 0 ? void 0 : newVal.length) > 0 ? newVal : undefined, name);
    }
  }, [value, onChange, name]);
  const valueMap = useMemo(() => listToMap(value, d => d, () => true), [value]);
  const rendererParams = useCallback((key, data) => ({
    name: keySelector(data),
    children: labelSelector(data),
    title: titleSelector ? titleSelector(data) : undefined,
    icons: iconSelector ? iconSelector(data) : undefined,
    disabled,
    variant: valueMap !== null && valueMap !== void 0 && valueMap[key] ? selectedButtonVariant : buttonVariant,
    onClick: handleOptionClick,
    spacing: smallButtons ? 'compact' : undefined,
    className: _cs(buttonClassName, styles.button, smallButtons && styles.smallButton)
  }), [smallButtons, titleSelector, iconSelector, valueMap, selectedButtonVariant, buttonClassName, buttonVariant, disabled, handleOptionClick, keySelector, labelSelector]);
  const filteredOptions = useMemo(() => selectedValueHidden ? options === null || options === void 0 ? void 0 : options.filter(option => !(valueMap !== null && valueMap !== void 0 && valueMap[keySelector(option)])) : options, [selectedValueHidden, valueMap, options, keySelector]);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.container, containerClassName)
  }, /*#__PURE__*/React.createElement(InputLabel, {
    className: labelContainerClassName,
    disabled: disabled
  }, label), /*#__PURE__*/React.createElement(ListView, {
    className: _cs(styles.suggestions, listClassName),
    keySelector: keySelector,
    data: filteredOptions,
    renderer: Button,
    rendererParams: rendererParams,
    filtered: false,
    pending: false,
    errored: false
  }), /*#__PURE__*/React.createElement(InputError, {
    className: errorContainerClassName
  }, error), !error && hint && /*#__PURE__*/React.createElement(InputHint, {
    className: hintContainerClassName
  }, hint));
}

export { MultiBadgeInput as default };
//# sourceMappingURL=index.js.map
